import {BicycleTypeEnum, QuestionnaireType} from "./AnswerEnums";

export type AdvisorConfig = {
    id: QuestionnaireType;
    displayName: string;
    questionFlow: string[];
    conditionalDependencies?: {
        questionId: string;
        requiredAnswers: Array<{
            question: string;
            values: unknown[];
        }>;
        insertAfter?: string;
    }[];
};

export const AdvisorConfigs: AdvisorConfig[] = [
    {
        id: QuestionnaireType.whole,
        displayName: "Gesamtberater",
        questionFlow: [
            "bicycle_type",
            "sex",
            "weight",
            "driving_frequency",
            "driving_duration",
            "pelvic_problems",
            "sitbone_distance",
            "hand_problems",
            "hand_size_measurement",
            "foot_problems",
            "leg_axis", // benötigt für Einlegesohlen
            "foot_type",    // benötigt für Einlegesohlen
            "foot_position", // benötigt für Pedale
            "shoe_size_measurement",
            "body_measurements",
            "privacy_agreement",
        ],
    },

    {
        id: QuestionnaireType.saddle,
        displayName: "Sattel Berater",
        questionFlow: [
            // "welcome_screen",
            "bicycle_type",
            "sex",
            "weight",
            "driving_frequency",
            "driving_duration",
            "pelvic_problems",
            "sitbone_distance",
            "privacy_agreement",
            // "result_screen"
        ]
    },
    {
        id: QuestionnaireType.handle,
        displayName: "Griffe Berater",
        questionFlow: [
            // "welcome_screen",
            "bicycle_type",
            "sex",
            "hand_problems",
            "hand_size_measurement",
            "privacy_agreement",
            // "result_screen"
        ]
    },
    {
        id: QuestionnaireType.handlebars,
        displayName: "Lenker Berater",
        questionFlow: [
            // "welcome_screen",
            "bicycle_type",
            "sex",
            "weight",
            "hand_problems",
            "privacy_agreement",
            // "result_screen"
        ],
        conditionalDependencies: [
            {
                questionId: "body_measurements",
                requiredAnswers: [
                    {
                        question: "bicycle_type",
                        values: [
                            BicycleTypeEnum.triathlon,
                            BicycleTypeEnum.roadRace,
                            BicycleTypeEnum.racingBike,
                            BicycleTypeEnum.gravel
                        ]
                    }
                ],
                insertAfter: "hand_problems"
            }
        ]
    },
    {
        id: QuestionnaireType.pedal,
        displayName: "Pedal Berater",
        questionFlow: [
            // "welcome_screen",
            "bicycle_type",
            "sex",
            "weight",
            "foot_problems",
            "foot_position",
            "shoe_size_measurement",
            "privacy_agreement",
            // "result_screen"
        ],
    },
    {
        id: QuestionnaireType.insole,
        displayName: "Einlegesohlen Berater",
        questionFlow: [
            // "welcome_screen",
            "bicycle_type",
            "sex",
            "foot_problems",
            "leg_axis",
            "foot_type",
            "shoe_size_measurement",
            "privacy_agreement",
        ],
    },
    {
        id: QuestionnaireType.clothing,
        displayName: "Bekleidungs Berater",
        questionFlow: [
            // "welcome_screen",
            "bicycle_type",
            "sex",
            "weight",
            "body_measurements",
            "hand_size_measurement",
            "pelvic_problems",
            "privacy_agreement",
        ],
    },

]